export const FooterLogo = () => {
    return (
<svg width="53" height="35" viewBox="0 0 53 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.4516 14.975L28.9298 1.07104L48.3468 1.07105C51.6483 1.07105 53.8325 4.50249 52.4372 7.49689L43.4553 26.7744C41.6289 30.6945 37.6984 33.2003 33.3767 33.2003H31.1599L43.136 7.49689L35.9379 7.49689L32.4538 14.975H22.4516Z" fill="white"/>
<path d="M30.4138 19.2963L23.9357 33.2003H4.51864C1.21717 33.2003 -0.966993 29.7688 0.428249 26.7744L9.41022 7.49689C11.2365 3.57685 15.1671 1.07105 19.4888 1.07105H21.7056L9.72951 26.7744H16.9276L20.4116 19.2963H30.4138Z" fill="white"/>
</svg>
    )
}